<template>
    <div class="group" v-if="skillGroup">
        <page-image-top class="group__header" :title="$t(`skills.groups.${skillGroup.name}.name`)"
                  :breadcrumbs="breadcrumbs"
                  :image="'/static/backgrounds/table-bottom.png'">
            <div class="section group_sub-navigation">
                <div class="container">
                    <ul>
                        <li>
                            <h3>
                                <span class="icon"><i class="fas fa-tasks"></i></span>
                                Færdigheder:
                            </h3>
                        </li>

                        <li v-for="skill in skills">
                            <router-link :to="{name: 'skills.skill', params: {group: skillGroup.name, skill: skill.name}}">
                                {{$t(`skills.${skill.name}.name`)}}
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </page-image-top>

        <div class="section">
            <div class="container">
                <div class="columns is-vcentered">
                    <div class="column is-6" style="padding: auto 100px">
                        <h2 class="is-size-4">{{$t(`skills.groups.${skillGroup.name}.description.headline`)}}</h2><br>
                        <p v-html="$t(`skills.groups.${skillGroup.name}.description.firstParagraph`)" /><br>
                        <p v-html="$t(`skills.groups.${skillGroup.name}.description.secondParagraph`)" />
                    </div>

                    <div class="column is-6">
                        <figure class="image">
                            <img :src="$t(`skills.groups.${skillGroup.name}.imageUrl`)" :alt="$t(`skills.groups.${skillGroup.name}.name`)">
                        </figure>
                    </div>
                </div>
            </div>
        </div>

        <div class="section has-background-light">
            <div class="container">
                <div class="columns is-multiline">
                    <div class="column is-4" v-for="skill in skills">
                        <router-link :to="{name: 'skills.skill', params: {group: skillGroup.name, skill: skill.name}}" exact>
                            <div class="box skill-example__box"
                                 :style="{backgroundImage: `url('${$t(`skills.${skill.name}.imageUrl`)}')`}">
                                <h4 class="is-size-4">{{$t(`skills.${skill.name}.name`)}}</h4>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/variables';

    .group__header {
        .group_sub-navigation {
            background-color: $white-ter;
            color: $black;
            padding: 10px;

            ul {
                li {
                    display: inline-block;

                    &:not(:first-child) {
                        padding-left: 25px;
                    }

                    a {
                        color: $black;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }

    .skill-example__box {
        height: 125px;
        border-radius: 0;

        h4 {
            background-color: $white;
            display: inline-block;
            padding: 5px 10px;
        }

        background-position: center center;
        background-size: cover;
    }
</style>

<script>
    import { mapGetters } from 'vuex';
    import PageImageTop from '@/global/components/PageImageTop';

    export default {
        computed: {
            ...mapGetters('skills', {
                skillGroups: 'skillGroups',
                isLoadingSkills: 'isLoading',
            }),

            skillGroup() {
                const { group } = this.$route.params;

                return this.skillGroups.find(skillGroup => skillGroup.name === group);
            },

            breadcrumbs() {
                return [
                    {
                        title: this.$t('pages.home.title'),
                        route: { name: 'home' },
                    },
                    {
                        title: this.$t('pages.groups-overview.title'),
                        route: { name: 'skills.groups-overview' },
                    },
                    {
                        title: this.$t(`skills.groups.${this.skillGroup.name}.name`),
                        route: { name: 'skills.group', params: { group: this.skillGroup.name } },
                    },
                ];
            },

            skills() {
                if (!this.skillGroup) {
                    return [];
                }

                const { skills } = this.skillGroup;

                return skills;
            },
        },

        mounted() {
            if (!this.skillGroups.length) {
                this.$store.dispatch('skills/loadSkillGroups');
            }
        },

        components: {
            PageImageTop,
        },
    };
</script>




// WEBPACK FOOTER //
// src/taskflex/skills/pages/Group.vue